import { isUndefinedOrNull, models, SsmClassId } from "../omnia"

import { colorToCss } from "@omnia/shared/color/color"

export const ssmClassColors = {
    [SsmClassId.VeryLow]: [255, 0, 0],
    [SsmClassId.Low]: [255, 255, 0],
    [SsmClassId.Optimum]: [37, 142, 0],
    [SsmClassId.High]: [17, 91, 239],
    [SsmClassId.VeryHigh]: [234, 0, 206]
}


export function getSsmGaugeStyle(classId: SsmClassId) {

    const [color, rotate] = isUndefinedOrNull(classId)
        ? [undefined, 0]
        : [ssmClassColors[classId], (180 / 5) * ((classId || 0) <= 0 ? 1 : classId)]

    return {
        "transform": "rotate(" + rotate + "deg)",
        "background-color": (color ? colorToCss(color) : "rgb(0,0,0)")
    }

}
